export const AnalyticContexts = {
	Source: 'objectSidebar',
};
